<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550)
  v-card
    v-card-title.pa-4(v-if="title")
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          div.text-xl.font-bold.neutral700--text.text-center {{ title }}
        v-col(cols="1" align="right")
          v-btn.ml-n3(text icon @click="onCloseDialog")
            v-icon(color="neutral700" :size="24") mdi-close
    v-divider(v-if="title")
    v-card-text.py-5
      .px-4.mb-4.neutral700--text
        .d-flex.align-center
          .text-md.font-semibold.mr-2 Selected date
          v-btn.button-sm.text-md(depressed readonly color="info500" dark) {{ selectedDate | convertToDateOnly }}
        v-divider.my-4
      yc-date-picker(:parentDate.sync="selectedDate" :minDate="minDate")
    v-card-actions.white.pa-0
      .d-flex.flex-column(style="width:100%")
        v-divider
        .d-flex.justify-end.pa-4
          v-btn.button-md.neutral700--text.underline.mr-2(text @click="onCloseDialog") {{ $t('cancel') }}
          v-btn.button-md(:loading="isLoading" color="primary" depressed @click="onConfirm") {{ $t('confirm') }}
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    open: {
      type: Boolean
    },
    parentDateDetails: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isLoading: false,
      selectedDate: null,
      title: null,
      minDate: null
    }
  },
  mounted () {
    if (this.parentDateDetails) {
      this.selectedDate = this.parentDateDetails.date ?? this.todayDate
      this.title = this.parentDateDetails.title
      if (this.parentDateDetails.minDate) {
        this.minDate = this.parentDateDetails.minDate
      }
    } else {
      this.selectedDate = this.todayDate
    }

  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    todayDate () {
      return DateTime.local().toISODate()
    }
  },
  methods: {
    onCloseDialog () {
      this.showDialog = false
    },
    onConfirm () {
      this.$emit('confirmed', this.selectedDate)
      this.onCloseDialog()
    }
  },
};
</script>

<style lang="scss" scoped>
</style>